import { FC } from 'react';
import { ExtendedDialog } from 'ui-component/extended/ExtendedDialog';
import { DecoratedKitRequestLine } from 'hooks/useGetDecoratedKitRequestLines';
import { KitRequestSubtype } from 'views/kitting/Kit/KitRequestContext';
import AllocationSummary from 'ui-component/AllocationSummary';
import SegmentButton from 'ui-component/Segment/SegmentButton';

type AllocatedPartsDialogProps = {
  open: boolean;
  onClose: () => void;
  rows: DecoratedKitRequestLine[];
  loading?: boolean;
  kitRequest?: KitRequestSubtype | null;
};

export const AllocatedPartsDialog: FC<AllocatedPartsDialogProps> = ({
  open,
  onClose,
  rows,
  loading,
  kitRequest,
}) => (
  <ExtendedDialog
    open={open}
    onCloseDialog={onClose}
    title="Allocated Parts"
    maxWidth="lg"
    fullWidth
    overrideComponents={{
      actions: (
        <SegmentButton onClick={onClose} color="primary" variant="contained">
          Close
        </SegmentButton>
      ),
    }}
  >
    <AllocationSummary lines={rows} kitRequest={kitRequest} loading={loading} />
  </ExtendedDialog>
);
